import React, { Component } from 'react'
import { connect } from 'react-redux'
import Hero from 'form/components/molecules/mHero'
import SuccessMessage from 'form/components/molecules/mSuccessMessage'
import ModalOverlay from 'form/components/molecules/mModalOverlay'
import LoaderOverlay from 'form/components/molecules/mLoaderOverlay'
import Form from 'form/components/organisms/oForm'
import { Layout, Breakpoints } from '@volkswagen-onehub/components-core'

class Home extends Component {
  render() {
    const { showForm, showError, showSuccess, showLoader } = this.props
    return (
      <>
        <div className="home">
          <Hero />
          <Layout
            appearance={{
              [Breakpoints.default]: [
                { name: '.', columns: 2 },
                { name: 'a', columns: 20 },
                { name: '.', columns: 2 }
              ]
            }}
          >
            {showForm && <Form />}
            {showSuccess && <SuccessMessage />}
            {showError && <ModalOverlay isOpen />}
            {showLoader && <LoaderOverlay />}
          </Layout>
        </div>
      </>
    )
  }
}

const mapStateToProps = ({ form }) => {
  const { showForm, showError, showSuccess, showLoader } = form

  return {
    showLoader,
    showForm,
    showError,
    showSuccess
  }
}
export default connect(mapStateToProps)(Home)
